import EPGChannelForm from './EPGChannelForm';

export default EPGChannelForm;
